function technicianData() {
  return {
    username: "000001",
    password: "123456",
  };
}

export default technicianData;
